import appleTouchIcon from './favicons/apple-touch-icon.png'
import favicon32 from './favicons/favicon-32x32.png'
import favicon16 from './favicons/favicon-16x16.png'
// import siteWebmanifest from './favicons/site.webmanifest'
import safariPinnedTab from './favicons/safari-pinned-tab.svg'

export default {
    appleTouchIcon,
    favicon32,
    favicon16,
    // siteWebmanifest,
    safariPinnedTab
}
